export const TOKEN_TYPE_MAP: Record<number, number> = {
  4: 7,
  1: 4,
  2: 2,
  6: 9,
  0: 0,
};

export const QLIGHT_BASE_URL = 'qb://qlight?needLoading=false&needback=true&needshare=false&needlongclick=false&enablepulldown=false&needtitle=true&titlebartype=0&layoutfromtop=true&fullscreen=false&transparentbg=false&showlogo=false&needprogress=false&reurl=';

